import locale from 'localization';

export const sharedCapitalColumns = [
  { key: 'membershipId', text: 'Membership ID', width: '15%' },
  { key: 'customerAccountNumber', text: 'Customer Account Number', width: '15%' },
  { key: 'name', text: locale.name, width: '15%' },
  { key: 'status', text: locale.status, width: '15%' },
  { key: 'balance', text: 'Balance', width: '15%' },
  { key: 'options', text: '', width: '5%' }
];
